import Vue from 'vue';
import VueRouter, {RouteConfig} from 'vue-router';
import AddNewKeywords from '@/components/add-new-keywords/add-new-keywords.component.vue';
import KeywordsToInsertBatchDetails from '@/components/keywords-to-insert-batch-details/keywords-to-insert-batch-details.component.vue';
import BulkDeleteKeywords from '@/components/bulk-delete-keywords/bulk-delete-keywords.component.vue';
import ImageClassifier from '@/components/image-classifier/image-classifier.component.vue';
import ListKeywordsV2 from '@/components/list-keywords-v2/list-keywords-v2.component.vue';
import KeywordDedupList from '@/components/keyword-dedup-list/keyword-dedup-list.component.vue';
import KeywordDedupCanonicalDetail from '@/components/keyword-dedup-canonical-detail/keyword-dedup-canonical-detail.component.vue';
import KeywordDedupDetail from '@/components/keyword-dedup-detail/keyword-dedup-detail.component.vue';
import VerticalKeyword from '@/components/vertical-keyword/vertical-keyword.component.vue';
import VerticalsList from '@/components/verticals-list/verticals-list.component.vue';
import AddVertical from '@/components/add-vertical/add-vertical.component.vue';
import EditVertical from '@/components/edit-vertical/edit-vertical.component.vue';
import Login from '@/components/login/login.component.vue';
import {getReturnUrl, isTokenExpired} from '@/helpers';

import VueSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

Vue.use(VueRouter);
Vue.component('v-select', VueSelect);

const routes: Array<RouteConfig> = [{
  path: '/',
  redirect: '/keywords-list',
}, {
  path: '/keywords-list-v2',
  redirect: to => ({
    path: '/keywords-list',
    query: to.query,
    hash: to.hash,
  }),
}, {
  path: '/keywords-list',
  name: 'KeywordsList',
  component: ListKeywordsV2,
  meta: {
    title: 'Keywords List | Revenuedriver S.R.L',
    requiresAuth: true,
  },
}, {
  path: '/keyword-dedup',
  name: 'KeywordDedupList',
  component: KeywordDedupList,
  meta: {
    title: 'Keyword Deduplication | Revenuedriver S.R.L',
    requiresAuth: true,
  },
}, {
  path: '/keyword-dedup/canonical/:clusterId',
  name: 'KeywordDedupCanonicalDetail',
  component: KeywordDedupCanonicalDetail,
  meta: {
    title: 'Canonical keyword cluster | Revenuedriver S.R.L',
    requiresAuth: true,
  },
}, {
  path: '/keyword-dedup/:id',
  name: 'KeywordDedupDetail',
  component: KeywordDedupDetail,
  meta: {
    title: 'Keyword Deduplication | Revenuedriver S.R.L',
    requiresAuth: true,
  },
}, {
  path: '/add-new-keywords',
  name: 'AddNewKeywords',
  component: AddNewKeywords,
  meta: {
    title: 'Add new keywords | Revenuedriver S.R.L',
    requiresAuth: true,
  },
}, {
  path: '/keywords-to-insert/batches/:batchId',
  name: 'KeywordsToInsertBatchDetails',
  component: KeywordsToInsertBatchDetails,
  meta: {
    title: 'Batch keywords | Revenuedriver S.R.L',
    requiresAuth: true,
  },
}, {
  path: '/bulk-delete-keywords',
  name: 'BulkDeleteKeywords',
  component: BulkDeleteKeywords,
  meta: {
    title: 'Bulk Delete Keywords | Revenuedriver S.R.L',
    requiresAuth: true,
  },
}, {
  path: '/verticals-list',
  name: 'VerticalList',
  component: VerticalsList,
  meta: {
    title: 'Verticals List | Revenuedriver S.R.L',
    requiresAuth: true,
  },
}, {
  path: '/add-vertical',
  name: 'AddVertical',
  component: AddVertical,
  meta: {
    title: 'Add Vertical | Revenuedriver S.R.L',
    requiresAuth: true,
  },
}, {
  path: '/vertical-keyword',
  name: 'VerticalKeyword',
  component: VerticalKeyword,
  meta: {
    title: 'Assign Vertical to Keyword | Revenuedriver S.R.L',
    requiresAuth: true,
  },
}, {
  path: '/edit-vertical/:id',
  name: 'EditVertical',
  component: EditVertical,
  meta: {
    title: 'Edit Vertical | Revenuedriver S.R.L',
    requiresAuth: true,
  },
}, {
  path: '/image-classifier',
  name: 'ImageClassifier',
  component: ImageClassifier,
  meta: {
    title: 'Image Classifier | Revenuedriver S.R.L',
    requiresAuth: true,
  },
}, {
  path: '/login',
  name: 'Login',
  component: Login,
  meta: {
    title: 'Login | Revenuedriver S.R.L',
  },
}, {
  path: '*',
  redirect: '/',
}];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta?.requiresAuth && isTokenExpired(localStorage.getItem('access-token') ?? '', 60 * 5)) {
    const returnUrl = getReturnUrl(to);
    next({path: '/login', query: {returnUrl}});
  } else {
    next();
  }
});

export default router;
